import { z } from "zod";

const PHONE_REGEX = /^\+?[\d\s\-()]{7,20}$/;

// Name: required, 2-100 chars. Uses dynamic error for empty vs too-short.
function requiredName() {
  return z
    .string({ error: "Name is required" })
    .trim()
    .min(2, {
      error: (iss) =>
        iss.input.length === 0
          ? "Name is required"
          : "Name must be at least 2 characters",
    })
    .max(100, { error: "Name must be less than 100 characters" });
}

// Phone: required, valid format. Dynamic error for empty vs invalid format.
function requiredPhone() {
  return z
    .string({ error: "Phone number is required" })
    .regex(PHONE_REGEX, {
      error: (iss) =>
        iss.input.length === 0
          ? "Phone number is required"
          : "Please enter a valid phone number",
    });
}

// Email: optional, valid format when provided
function optionalEmail() {
  return z
    .string()
    .email({ error: "Please enter a valid email address" })
    .or(z.literal(""))
    .optional();
}

// Notes: optional, max 500 chars
function optionalNotes() {
  return z
    .string()
    .max(500, { error: "Notes must be less than 500 characters" })
    .optional();
}

export const bookingAppointmentSchema = z.object({
  client_name: requiredName(),
  client_phone: requiredPhone(),
  client_email: optionalEmail(),
  notes: optionalNotes(),

  start_time: z
    .string({ error: "Please select a time slot" })
    .min(1, { error: "Please select a time slot" }),

  service_id: z
    .string({ error: "Please select a service" })
    .min(1, { error: "Please select a service" }),
});

export const operationsAppointmentSchema = z.object({
  client_name: requiredName(),
  client_phone: requiredPhone(),
  client_email: optionalEmail(),
  notes: optionalNotes(),

  start_time: z
    .string({ error: "Please select a time slot" })
    .min(1, { error: "Please select a time slot" }),

  staff_id: z
    .string({ error: "Please select a staff member" })
    .min(1, { error: "Please select a staff member" }),

  service_id: z
    .string({ error: "Please select a service" })
    .min(1, { error: "Please select a service" }),

  status: z
    .string({ error: "Please select a status" })
    .min(1, { error: "Please select a status" }),
});
